import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { SignalTileStreamRequest } from 'widgets/signalTiles/signalTile/api/SignalTileStreamRequest';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers';
import { WidgetType } from 'widgets/WidgetType';

export function signalTileStreamRequestBuilders(
    widgetType: WidgetType,
    initialConfigState: SignalTileConfigState
) {
    function toRequestUid(
        symbol: string,
        configState: SignalTileConfigState
    ): string {
        const config = configState ?? initialConfigState;
        const { numWindows } = config;
        return `${widgetType}-${symbol}|${numWindows}`;
    }

    function requestToStreamKey(request: SignalTileStreamRequest): string {
        const { symbol, numWindows } = request;
        return toRequestUid(symbol, { numWindows, bucketSize: 5 });
    }

    function buildRequest(
        symbol: string,
        symbology: SymbologyValues,
        configState: SignalTileConfigState
    ): SignalTileStreamRequest {
        const config = configState ?? initialConfigState;
        const { numWindows } = config;
        return {
            symbol,
            symbology,
            numWindows,
        };
    }

    const {
        createWidgetRequestUid,
        getWidgetStreamRequestInfo,
        getStreamRequestInfosForSymbols,
    } = buildSymbolDependentRequestHelpers<
        SignalTileStreamRequest,
        SignalTileConfigState
    >(toRequestUid, requestToStreamKey, buildRequest, initialConfigState);

    return {
        createSignalTileRequestUid: createWidgetRequestUid,
        getSignalTileStreamRequestInfo: getWidgetStreamRequestInfo,
        getSignalTileStreamRequestInfosForSymbols:
            getStreamRequestInfosForSymbols,
        toSignalRequestUid: toRequestUid,
    };
}
